export default function loadScript({ src, onLoaded, id = null }) {
  const scriptElement = document.createElement('script');

  scriptElement.type = 'text/javascript';
  scriptElement.src = src;
  scriptElement.async = true;

  if (typeof onLoaded === 'function') {
    scriptElement.onload = onLoaded;
  }

  if (id) {
    scriptElement.id = id;
  }

  document.body.appendChild(scriptElement);
}
